<template>
  <v-container
    grid-list-xl

    fluid
  >
    <v-row justify="center">

      <v-col>
        <v-card>
          <v-card-text>
            <h2 class="font-weight-light mb-4">
              Customer
            </h2>

            <v-row>
              <v-col>
                <v-btn
                  :to="{ name: 'CustomerEdit', params: { 'id': id }}">
                  {{$t("customers.show.edit")}}
                </v-btn>

              </v-col>
              <v-col>
                <v-btn
                  @click="goToCustomer">
                  {{$t("customers.show.goto")}}
                </v-btn>

              </v-col>
              <v-col>
                <v-btn
                  @click="deleteCustomer">
                  {{$t("customers.show.delete")}}
                </v-btn>

              </v-col>

            </v-row>


            <v-container class="pa-0"  fluid>

              <v-row align="end">
                <v-col cols="1" md="3">
                  <div class="h2">
                    {{$t('customer.name')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{name}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="1" md="3">
                  <div class="h2">
                    {{$t('customer.logicalName')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{logicalName}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="1" md="3">
                  <div class="h2">
                    {{$t('customer.active')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    <div v-if="this.active">{{$t("global.yes")}}</div><div v-else>{{$t("global.no")}}</div>
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="1" md="3">
                  <div class="h2">
                    {{$t('customer.availableLanguages')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{availableLanguages}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="1" md="3">
                  <div class="h2">
                    {{$t('customer.riskMatrixType')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{riskMatrixType}}
                  </div>
                </v-col>
              </v-row>

      </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>

    import api from '../components/backend/backend-api'

    export default {
        data() {
            return {
                id:"",
                name: "",
                logicalName: '',
                availableLanguages:[],
                active:"",
              riskMatrixType:""

            }
        },
        methods: {
            getCustomer(id) {
                api.getCustomer(id).then(response => {
                    this.id = response.id
                    this.name = response.name
                    this.logicalName = response.logicalName
                    this.availableLanguages = response.availableLanguages
                    this.active = response.active
                  this.riskMatrixType = response.riskMatrixType

                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            goToCustomer() {
                api.gotoCustomer(this.id).then(response => {
                    this.$store.commit('setCustomer', response.name)
                  this.$store.commit('setCustomerLogicalId', response.logicalName)
                  this.$store.commit('setRiskMatrixType', response.riskMatrixType)
                    this.$store.commit('setAvailableLanguages', response.availableLanguages)
                    this.$router.push("/projects")
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            deleteCustomer () {
                if (confirm(this.$i18n.t('customers.show.deleteBody')))
                {
                    api.deleteCustomer(this.id).then(response => {
                        this.$router.push("/customers")
                    })
                        .catch(error => {
                            this.$store.commit('setErrorMsg', error)
                            console.log(error)
                            //    this.errors.push(error)
                        })


                }
            },
        },
        mounted() {
           this.getCustomer(this.$route.params.id)
        }
    }
</script>
